import getMemberToken from '../../utils/getMemberToken';

const apiFetch = async (url, options, tokenErrorDescription) => {
  const token = getMemberToken();
  if (!token) {
    throw new Error(tokenErrorDescription);
  }
  const headers = new Headers();
  headers.append('Accept', 'application/json');
  headers.append('Content-Type', 'application/json');
  headers.append('membership-session-token', token);
  const response = await fetch(url, {headers, ...options});
  return response;
};

export default apiFetch;
